export function searching(initialData: Array<String>, query: string, keys: any) {
  let searchedResult = initialData.filter((data: any) =>
    keys.some((key: any) => data[key].toString().toLowerCase().includes(query))
  )
  return searchedResult
}
